export default __webpack_public_path__ + "static/media/06-microsoft2023.b63cf753.jpg";